import React from 'react'
import { ThreeDots } from 'react-loader-spinner'

export default function Loader({ className }) {
    return (
        <div className="flex justify-center items-center">
            <ThreeDots
                height="10"
                color={className || "#ffffff"}
                ariaLabel="circles-loading"
                wrapperStyle={{}}
                wrapperClass={className}
                visible={true}
            />
        </div>
    )
}
